import type { ApiQuery, ApiRequestBody, ApiResponse } from "@takt/api-contracts"
import type { ApiClient } from "../client"
import type { NumberQueryFields, PaginatedQuery } from "./query-types"

type GeneratedAdminActivityQuery = NonNullable<ApiQuery<"/v1/admin/activity", "get">>
export type AdminActivityQuery = NumberQueryFields<PaginatedQuery<GeneratedAdminActivityQuery>, "companyId">
export type AdminActivityResponse = ApiResponse<"/v1/admin/activity", "get", 200>
type GeneratedAdminAppointmentsQuery = NonNullable<ApiQuery<"/v1/admin/appointments", "get">>
export type AdminAppointmentsQuery = NumberQueryFields<PaginatedQuery<GeneratedAdminAppointmentsQuery>, "companyId">
export type AdminAppointmentsResponse = ApiResponse<"/v1/admin/appointments", "get", 200>
export type AdminDashboardResponse = ApiResponse<"/v1/admin/dashboard", "get", 200>
export type AdminReportQuery = NonNullable<ApiQuery<"/v1/admin/reports", "get">>
export type AdminReportResponse = ApiResponse<"/v1/admin/reports", "get", 200>
type GeneratedAdminReviewsQuery = NonNullable<ApiQuery<"/v1/admin/reviews", "get">>
export type AdminReviewsQuery = NumberQueryFields<PaginatedQuery<GeneratedAdminReviewsQuery>, "companyId" | "rating">
export type AdminReviewsResponse = ApiResponse<"/v1/admin/reviews", "get", 200>
type GeneratedAdminReviewReportsQuery = NonNullable<ApiQuery<"/v1/admin/review-reports", "get">>
export type AdminReviewReportsQuery = NumberQueryFields<PaginatedQuery<GeneratedAdminReviewReportsQuery>, "companyId">
export type AdminReviewReportsResponse = ApiResponse<"/v1/admin/review-reports", "get", 200>
export type AdminReviewReport = ApiResponse<"/v1/admin/reviews/{reviewId}/reports", "get", 200>
export type AdminReviewReportDecisionInput = ApiRequestBody<"/v1/admin/reviews/{reviewId}/report-decision", "post">
export type UserSupportWorkspace = ApiResponse<"/v1/admin/users/{userId}", "get", 200>

export function createAdminEndpoints(client: ApiClient) {
    return {
        listAdminActivity(query: AdminActivityQuery = {}) {
            return client.get<AdminActivityResponse>("/admin/activity", { query })
        },
        listAdminAppointments(query: AdminAppointmentsQuery = {}) {
            return client.get<AdminAppointmentsResponse>("/admin/appointments", { query })
        },
        getAdminDashboard() {
            return client.get<AdminDashboardResponse>("/admin/dashboard")
        },
        getAdminOperationalReport(query: AdminReportQuery) {
            return client.get<AdminReportResponse>("/admin/reports", { query })
        },
        listAdminReviews(query: AdminReviewsQuery = {}) {
            return client.get<AdminReviewsResponse>("/admin/reviews", { query })
        },
        listAdminReviewReports(query: AdminReviewReportsQuery = {}) {
            return client.get<AdminReviewReportsResponse>("/admin/review-reports", { query })
        },
        getAdminReviewReport(reviewId: number) {
            return client.get<AdminReviewReport>(`/admin/reviews/${reviewId}/reports`)
        },
        decideAdminReviewReport(reviewId: number, input: AdminReviewReportDecisionInput) {
            return client.post<AdminReviewReport>(`/admin/reviews/${reviewId}/report-decision`, input)
        },
        restoreAdminReviewComment(reviewId: number) {
            return client.post<AdminReviewReport>(`/admin/reviews/${reviewId}/restore-comment`)
        },
        getUserSupportWorkspace(userId: string) {
            return client.get<UserSupportWorkspace>(`/admin/users/${encodeURIComponent(userId)}`)
        },
    }
}
